import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "@phosphor-icons/react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate(user.role === "rep" ? "/portal" : "/"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { const u = await login(email, password); navigate(u.role === "rep" ? "/portal" : "/"); }
    catch (err) { setError(apiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4">
      <div className="absolute inset-0 opacity-[0.15]"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1557683316-973673baf926?crop=entropy&cs=srgb&fm=jpg&q=85')", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
      <div className="relative z-10 w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-sm bg-primary text-primary-foreground">
            <ShieldCheck size={26} weight="fill" />
          </div>
          <h1 className="font-heading text-2xl font-black tracking-tight">Partner Command Center</h1>
          <p className="mt-1 text-sm text-muted-foreground">The command + money layer over GHL</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-sm border border-border bg-card p-6" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="overline">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} required
              onChange={(e) => setEmail(e.target.value)} className="font-mono" placeholder="you@company.com" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="overline">Password</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} required
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
